import { render } from "./SecondaryMaterial.vue?vue&type=template&id=14bad476&scoped=true&ts=true"
import script from "./SecondaryMaterial.vue?vue&type=script&lang=ts"
export * from "./SecondaryMaterial.vue?vue&type=script&lang=ts"

import "./SecondaryMaterial.vue?vue&type=style&index=0&id=14bad476&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14bad476"]])

export default __exports__